import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的项目财务ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  trainee_cost: [
    {...makeRule('请输入实习生成本', 'number')},
  ],
  offline_cost: [
    {...makeRule('请输入线下成本', 'number')},
  ],
  ticket_amount: [
    {...makeRule('请输入开票金额', 'number')},
  ],
  rate_amount: [
    {...makeRule('请输入税金', 'number')},
  ],
  receipt_amount: [
    {...makeRule('请输入收款金额', 'number')},
  ],
  bank_flow_num: [
    {...makeRule('请输入银行流水')},
  ],
  interest_cost: [
    {...makeRule('请输入利息成本', 'number')},
  ],
  return_rate: [
    {...makeRule('请输入回款率', 'number')},
  ],
  actual_gross_interest: [
    {...makeRule('请输入实际毛利', 'number')},
  ],
  actual_gross_interest_rate: [
    {...makeRule('请输入实际毛利率', 'number')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/customer-project/project-finance.rules.js